var $body = $("body"),
  $doc = $(document);

$doc.on("click", "[data-open-newsletter-popup-custom]", (event) => {
  event.preventDefault();
  event.stopPropagation();

  var $input = $(".newsletter-form__field-wrapper .field__input");
  var $inputEmailPopup = $(".newsletter-popup-custom [name='contact[email]']");

  if ($input[0]?.checkValidity()) {
    $inputEmailPopup.val($input.val());
    $body.addClass("newsletter-custom-show");
  } else {
    $input[0]?.reportValidity();
  }
});

const closeNewsletterPopup = () => {
  $body.removeClass("newsletter-custom-show");
  $(
    ".halo-newsletter-custom-popup .form-field, .halo-newsletter-custom-popup .button"
  ).removeClass("hidden");
  $(".halo-newsletter-custom-popup .form-message").addClass("hidden");
};

$doc.on("click", "[data-close-newsletter-custom-popup]", closeNewsletterPopup);
$doc.on("click", (event) => {
  if (
    $body.hasClass("newsletter-custom-show") &&
    !$(event.target).closest("[data-newsletter-custom-popup]").length
  ) {
    closeNewsletterPopup();
  }
});

const formMessage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const error =
    urlParams.has("form_type") && urlParams.get("form_type") === "contact";
  const posted =
    urlParams.has("contact_posted") &&
    urlParams.get("contact_posted") === "true";

  if (posted || error) {
    const formMessage = $(
      `[data-form-message="${localStorage.getItem("contact_form")}"]`
    );
    let delay = $body.hasClass("template-product") ? 1600 : 400;

    if (formMessage.data("form-message") === "newsletterCustom") {
      $(
        ".halo-newsletter-custom-popup .form-field, .halo-newsletter-custom-popup .button , .halo-newsletter-custom-popup .des_bottom, .newsletter-popup-custom .text"
      ).addClass("hidden");
      setTimeout(() => $body.addClass("newsletter-custom-show"), delay);

      window.history.replaceState({}, document.title, location.pathname);

      if (error) {
        $(".newsletter-form__message--error").addClass("hidden");
        $("html, body").animate(
          { scrollTop: formMessage.offset().top - window.innerHeight / 2 },
          700
        );
      }
    }
  }

  $doc.on("click", "[data-button-message]", (event) => {
    localStorage.setItem(
      "contact_form",
      $(event.target).data("button-message")
    );
  });
};

formMessage();


document.addEventListener("DOMContentLoaded", function () {
    const parallaxVideos = document.querySelectorAll(".is-parallax-video");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = "1";
            } else {
                entry.target.style.opacity = "0";
            }
        });
    }, { threshold: 0.2 }); 

    parallaxVideos?.forEach((video) => observer.observe(video));
});
